<template>
  <PalettePicker 
    ref="dropdown"
    :boundary="boundary"
    :value="_color" 
    :alpha="_alpha"
    @change="onChange"
    @show="onShow"
    @shown="onShown"
    @hide="onHide"
  >
    <template #icon v-if="$slots.icon">
      <slot name="icon"></slot> 
    </template>
  </PalettePicker>
</template>

<script>
import PalettePicker from "@components_system/Shared/Tools/Box/PalettePicker/PalettePicker";

export default {
  components: {
    PalettePicker,
  },
  props: {
    value: {
      // default: "#000000",
      // required: true,
      // type: String,
    },
    color: {
      // default: "#000000",
      // required: true,
      // type: String,
    },
    alpha: {
      // default: "#000000",
      // required: true,
      // type: String,
    },
    boundary: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    _color() {
      if (this.value && this.value.color) return this.value.color;
      return this.color;
    },
    _alpha() {
      if (this.value && this.value.alpha) return this.value.alpha;
      return this.alpha;
    },
  },
  methods: {
    show() {
      this.$refs.dropdown.palatteShown();
    },

    onShow(event) {
      this.$emit("show", event);
    },
    onShown(event) {
      this.$emit("shown", event);
    },
    onHide(event) {
      this.$emit("hide", event);
    },
    onChange(value) {
      this.$emit("change", value);
    },
  },
};
</script>